import { Action, createReducer, on } from "@ngrx/store";
import * as DeviceMtmaActions from './device-mtma.actions';
import { MtmaUploadResponseData } from "src/app/model/api/data-rest";

export interface State {
   mtmaUploadResponseData: MtmaUploadResponseData;
}

const initialState: State = {
   mtmaUploadResponseData: null,
}

const deviceMtmaReducer = createReducer(
   initialState,

   on(DeviceMtmaActions.resetMtmaImportCsv, (state) => ({
      ...state,
      mtmaUploadResponseData: null
   })),
   on(DeviceMtmaActions.postMtmaImportCsv, (state) => ({
      ...state,
      mtmaUploadResponseData: null
   })),
   on(DeviceMtmaActions.postMtmaImportCsvSuccess, (state, payload) => ({
      ...state,
      mtmaUploadResponseData: payload.mtmaUploadResponseData
   })),
   on(DeviceMtmaActions.postMtmaImportCsvFailed, (state, payload) => ({
      ...state,
      mtmaUploadResponseData: payload.mtmaUploadResponseData
   })),
);

export const reducer = (state: State | undefined, action: Action): State => deviceMtmaReducer(state, action);
